export default __webpack_public_path__ + "static/media/gallery_29.7c91efeb.jpg";